<ng-template #emptyState>
    <div class="empty-state-wrapper">
        <div class="empty-state">
            <span
                class="building-wrapper"
                hamIconShapes
                icon="assets/hamIcons/clipboard-check-outline.svg"
                [size]="'50px'"
            >
            </span>
            <div class="text1">
                {{ 'cpmm_workflow_tasks_empty' | i18next }}
            </div>
            <div class="text2" *ngIf="area === 'MANDATE_MANAGEMENT'">
                {{ 'cpmm_workflow_tasks_empty_sync_instructions_MM' | i18next }}
            </div>
            <div class="text2" *ngIf="area === 'CLOSING_PROCESS'">
                {{ 'cpmm_workflow_tasks_empty_sync_instructions_CP' | i18next }}
            </div>
            <ham-button type="submit" (buttonClick)="onSyncWorkflow()">
                {{ 'aumico_workflow_sync' | i18next }}
            </ham-button>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="tasks && tasks.length > 0; else emptyState">
    <div class="workflow-form">
        <div class="wf-header">
            <!-- 1) optional sub-nav for taskType -->
            <div class="wf-tabs" *ngIf="tabs.length > 1 && selectedTabKeyLoaded">
                <ham-button
                    *ngFor="let tab of tabs"
                    variant="primary"
                    size="base"
                    [active]="tab.key === selectedTabKey"
                    [inactive]="tab.key !== selectedTabKey"
                    (buttonClick)="selectTab(tab)"
                >
                    <div style="display: flex; gap: 8px">
                        <span>{{ tab.label }}</span>
                        <span hamBadge color="grey2" *ngIf="tab.countDone !== tab.countTotal"
                            >{{ tab.countDone }}/{{ tab.countTotal }}</span
                        >
                        <span hamBadge color="green" *ngIf="tab.countDone === tab.countTotal"
                            >{{ tab.countDone }}/{{ tab.countTotal }}</span
                        >
                    </div>
                </ham-button>
            </div>

            <!-- 2) export actions -->
            <div class="wf-actions">
                <export-documents-zip-filter-dropdown (exportZipClicked)="exportZipClicked($event)">
                </export-documents-zip-filter-dropdown>
                <export-tasks-filter-dropdown [area]="area" (exportExcelClicked)="exportTasksExcel($event)">
                </export-tasks-filter-dropdown>
            </div>
        </div>
        <div class="select-all-wrapper">
            <span [checked]="selectedTabKey && selectAll.has(selectedTabKey)" hamCheckbox (change)="toggleCheckAll()"> </span>
            <span class="select-all-text">{{ 'aumico_MMCP_overview_bulk_edit_select_all' | i18next }}</span>
        </div>

        <!-- 3) accordion per section -->
        <div class="wf-content" *ngIf="selectedTabKeyLoaded">
            <ham-accordion [multi]="true">
                <div
                    *ngFor="let sec of sections; trackBy: trackBySectionId"
                    class="accordion-item-wrapper"
                    [ngClass]="{
                        'scroll-highlight-wrapper': highlightedSectionId === sec.id
                    }"
                >
                    <ham-accordion-item
                        [isOpened]="openAccordions[sec.id]"
                        (toggle)="toggleAccordion(sec.id)"
                        #accordionItem
                        backgroundColor="#fff"
                        [ngClass]="{
                            'not-applicable': sec.isNotApplicable
                        }"
                    >
                    <div accordion-header class="accordion-header">
                        <span class="accordion-icon">
                            <span
                                *ngIf="!accordionItem.expanded"
                                hamIconShapes
                                icon="assets/hamIcons/chevron-down.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                [mustBubbleEvent]="true"
                            ></span>
                            <span
                                *ngIf="accordionItem.expanded"
                                hamIconShapes
                                icon="assets/hamIcons/chevron-up-outline.svg"
                                [variant]="'transparent'"
                                [size]="'regular'"
                                [mustBubbleEvent]="true"
                            ></span>
                        </span>
                        <span class="accordion-title">{{ sec.name }}</span>
                        <span
                            hamBadge
                            color="grey"
                            *ngIf="!sec.hasOverdue && sec.countDone != sec.countTotal && !sec.isNotApplicable"
                            >{{ sec.countDone }}/{{ sec.countTotal }}</span
                        >
                        <span
                            hamBadge
                            color="red"
                            *ngIf="sec.hasOverdue && !(sec.countDone == sec.countTotal) && !sec.isNotApplicable"
                            >{{ sec.countDone }}/{{ sec.countTotal }}</span
                        >
                        <span
                            hamBadge
                            color="green"
                            *ngIf="!sec.hasOverdue && sec.countDone == sec.countTotal && !sec.isNotApplicable"
                            >{{ sec.countDone }}/{{ sec.countTotal }}</span
                        >
                        <ng-container *ngIf="sec.isNotApplicable">
                            <div class="ham-badge" hamBadge color="grey" size="small">
                                {{ 'aumico_ui_not_applicable' | i18next }}
                            </div>
                        </ng-container>
                        <span
                            #optionsButtonWrapper
                            class="section-options"
                            hamIconShapes
                            icon="assets/hamIcons/dots-horizontal.svg"
                            [variant]="'transparent'"
                            [size]="'regular'"
                            (click)="toggleOptionsMenu($event, sec.id, optionsButtonWrapper)"
                        ></span>
                        <span
                            class="section-options-flyout menu-flyout"
                            *ngIf="openedOptionsMenuSectionId === sec.id"
                            hamFlyout
                            [position]="flyoutPosition"
                            (closeFlyout)="closeOptionsMenu()"
                        >
                            <div class="flyout-content">
                                <div
                                    class="section-option-item"
                                    *ngIf="!sec.isNotApplicable"
                                    (click)="onMarkSectionNotApplicable(sec.id); $event.stopPropagation()"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/archive-outline.svg"
                                        [variant]="'transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_not_applicable'
                                            | i18next : { defaultValue: 'Not Applicable for this Mandate' }
                                    }}</span>
                                </div>
                                <div
                                    class="section-option-item"
                                    *ngIf="sec.isNotApplicable"
                                    (click)="onMarkSectionApplicable(sec.id); $event.stopPropagation()"
                                >
                                    <span
                                        hamIconShapes
                                        icon="assets/hamIcons/archive-outline.svg"
                                        [variant]="'transparent'"
                                        [size]="'s'"
                                    ></span>
                                    <span>{{
                                        'aumico_pm_tasks_mark_applicable'
                                            | i18next : { defaultValue: 'Applicable for this Mandate' }
                                    }}</span>
                                </div>
                            </div>
                        </span>
                    </div>
                    <div accordion-body class="accordion-body">
                        <!-- you can swap in your table-of-choice here -->
                        <ng-container>
                            <pm-tasks-table
                                [documentExpirationDate]="documentExpirationDate"
                                [tasks]="sec.tasks"
                                [assigneeOptions]="assigneeOptions"
                                [deletedUsers]="deletedUsers"
                                [annotationsMap]="annotationsMap"
                                [documentsMap]="documentsMap"
                                [documentsInProgressUpload]="documentsInProgressUpload"
                                [currentUserId]="currentUserId"
                                (addTask)="addTaskEvent($event)"
                                (updateTask)="updateTaskEvent($event)"
                                (deleteTask)="deleteTaskEvent($event)"
                                (annotationAdded)="annotationAdded.emit($event)"
                                (annotationChanged)="annotationChanged.emit($event)"
                                (annotationRemoved)="annotationRemoved.emit($event)"
                                (documentRemoved)="onDocumentRemoved($event)"
                                (documentsAdded)="onDocumentsAdded($event)"
                                (documentsAddedInProgress)="onDocumentsAddedInProgress($event)"
                                (openFile)="onOpenFile($event)"
                                (downloadFile)="onDownloadFile($event.fileId, $event.documentName)"
                                [sectionId]="sec.id"
                                [area]="area"
                                [taskType]="selectedTabKey"
                                (stopPolling)="onStopPolling($event)"
                                (startPolling)="onStartPolling($event)"
                                [sectionToggled]="sectionToggled.has(sec.id)"
                                [selectedTaskIds]="selectedTaskIds"
                                (toggleSelectAll)="toggleSectionSelectAll(sec)"
                                (toggleSelectTask)="toggleCheckTask($event)"
                            ></pm-tasks-table>
                        </ng-container>
                    </div>
                    </ham-accordion-item>
                </div>
            </ham-accordion>
        </div>
    </div>
</ng-container>
